var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegistrationFinish',{attrs:{"tournament-id":_vm.tournamentId,"team-hash":_vm.teamHash,"heartstone-decks":_vm.heartstoneDecks},on:{"done":function($event){return _vm.$emit('closeModal')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }